import Vue from 'vue'
import Vuex from 'vuex'
import { login as loginApi, logout as logoutApi, getUserInfo, getSiteConfig } from '@/api'
import { setToken, removeToken, getToken, getCookieToken, setUser, removeUser } from '@/utils/storage'
import router from '@/router'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    siteName: '漫猫资料站',
    token: getToken() || getCookieToken() || '',
    userInfo: null,
    isLoggedIn: !!(getToken() || getCookieToken())
  },

  getters: {
    siteName: state => state.siteName,
    token: state => state.token,
    userInfo: state => state.userInfo,
    isLoggedIn: state => state.isLoggedIn,
    username: state => state.userInfo?.username || '',
    avatar: state => state.userInfo?.avatar || ''
  },

  mutations: {
    SET_SITE_NAME(state, name) {
      state.siteName = name
      document.title = name
    },
    SET_TOKEN(state, token) {
      state.token = token
      setToken(token)
      document.cookie = `hualing_token=${token}; path=/; max-age=86400`
    },
    SET_USER_INFO(state, userInfo) {
      state.userInfo = userInfo
      state.isLoggedIn = !!userInfo
      setUser(userInfo)
    },
    CLEAR_USER(state) {
      state.token = ''
      state.userInfo = null
      state.isLoggedIn = false
      removeToken()
      removeUser()
      document.cookie = 'hualing_token=; path=/; max-age=0'
    }
  },

  actions: {
    async getSiteConfig({ commit }) {
      try {
        const res = await getSiteConfig()
        if (res.data?.siteName) {
          commit('SET_SITE_NAME', res.data.siteName)
        }
      } catch (error) {
        console.error('获取网站配置失败:', error)
      }
    },

    async login({ commit, dispatch }, loginData) {
      const res = await loginApi(loginData)
      const { token } = res.data
      commit('SET_TOKEN', token)
      await dispatch('fetchUserInfo')
      return res
    },

    async fetchUserInfo({ commit }) {
      try {
        const res = await getUserInfo()
        commit('SET_USER_INFO', res.data)
        return res.data
      } catch (error) {
        commit('CLEAR_USER')
        throw error
      }
    },

    async logout({ commit }) {
      try {
        await logoutApi()
      } finally {
        commit('CLEAR_USER')
      }
    },

    async checkLogin({ commit, state }) {
      if (!state.token) {
        return false
      }
      try {
        await getUserInfo()
        return true
      } catch (error) {
        commit('CLEAR_USER')
        return false
      }
    }
  }
})